import { DEFAULT_SSO_URLS, SsoUrls } from './default';
import { appName } from 'context';


const BRAND_SSO_MAPPING: Record<string, () => Promise<Partial<SsoUrls>>> = {
    AvMed: () => import('./Brands/Avmed').then((mod) => mod.getAvmedSSOUrls()),
    SHP: () => import('./Brands/Sentara').then((mod) => mod.getSentaraSSOUrls()),
};

// Function to get URLs based on the current brand and environment
export const getSSOUrls = async (): Promise<SsoUrls> => {
    const ENV = process.env.REACT_APP_ENVIRONMENT?.toLowerCase();
    const baseUrls = DEFAULT_SSO_URLS(ENV);
    const brandOverrides = await (BRAND_SSO_MAPPING[appName]?.() ?? Promise.resolve({}));
    return { ...baseUrls, ...brandOverrides };
};